import { render, staticRenderFns } from "./recommendations.vue?vue&type=template&id=24d6f730&lang=html"
import script from "./recommendations.vue?vue&type=script&lang=js"
export * from "./recommendations.vue?vue&type=script&lang=js"
import style0 from "./recommendations.vue?vue&type=style&index=0&id=24d6f730&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports